import { useEffect } from 'react';
import { courseTypesLabels } from '@/constants/catalog/course';
import { CourseTypes } from '@/models/catalog/course';
import { ProfileStepIds } from '@/models/recommendation';
import { SelectQuestion } from '@/packages/profile-quiz/components/questions/select-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import {
  ProfileFields,
  type QuestionProps,
} from '@/packages/profile-quiz/context/profile-quiz/types';

export const CourseTypesStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();

  useEffect(() => {
    const hasAtLeastOneCourseType = (answers.course_types?.length ?? 0) > 0;
    setCurrentStepValid(hasAtLeastOneCourseType);
  }, [answers.course_types, setCurrentStepValid]);

  const handleToggleCourseType = (courseType: CourseTypes) => {
    if (answers.course_types?.includes(courseType)) {
      setQuizAnswer(
        ProfileFields.CourseTypes,
        answers.course_types?.filter((type) => type !== courseType)
      );
    } else {
      setQuizAnswer(ProfileFields.CourseTypes, [
        ...(answers.course_types ?? []),
        courseType,
      ]);
    }
  };

  return (
    <SelectQuestion
      questionTitle="📚 Qual tipo de curso você tem mais interesse em fazer?"
      questionId={ProfileStepIds.CourseTypes}
      processedResponseText="Entendido! Assim consigo direcionar melhor as suas recomendações, focando no seu interesse."
      options={Object.values(CourseTypes).map((type) => ({
        label: courseTypesLabels[type],
        value: type,
      }))}
      handleToggleAnswer={handleToggleCourseType}
      currentValues={answers.course_types}
    />
  );
};
